import React from 'react';

export const PickerRightArrow = ({ className }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.25 11.75L10.25 8.75L7.25 5.75" stroke="#0A7593" />
  </svg>
);

export const PickerLeftArrow = ({ className }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.25 5.75L7.25 8.75L10.25 11.75" stroke="#0A7593" />
  </svg>
);

export const CalendarIcon = ({ className }) => (
  <svg
    width="11"
    height="13"
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.8877 1.8598H8.07689V1.04899C8.07689 0.919962 8.02564 0.796222 7.9344 0.704989C7.84317 0.613755 7.71943 0.5625 7.59041 0.5625C7.46138 0.5625 7.33764 0.613755 7.24641 0.704989C7.15517 0.796222 7.10392 0.919962 7.10392 1.04899V1.8598H4.185V1.04899C4.185 0.919962 4.13374 0.796222 4.04251 0.704989C3.95128 0.613755 3.82754 0.5625 3.69851 0.5625C3.56949 0.5625 3.44575 0.613755 3.35452 0.704989C3.26328 0.796222 3.21203 0.919962 3.21203 1.04899V1.8598H2.40122C1.92813 1.8598 1.47441 2.04773 1.13989 2.38226C0.805365 2.71678 0.617432 3.17049 0.617432 3.64358V10.7787C0.617432 11.2518 0.805365 11.7055 1.13989 12.04C1.47441 12.3746 1.92813 12.5625 2.40122 12.5625H8.8877C9.36079 12.5625 9.8145 12.3746 10.149 12.04C10.4836 11.7055 10.6715 11.2518 10.6715 10.7787V3.64358C10.6715 3.17049 10.4836 2.71678 10.149 2.38226C9.8145 2.04773 9.36079 1.8598 8.8877 1.8598ZM2.40122 2.83277H3.21203V3.64358C3.21203 3.77261 3.26328 3.89634 3.35452 3.98758C3.44575 4.07881 3.56949 4.13007 3.69851 4.13007C3.82754 4.13007 3.95128 4.07881 4.04251 3.98758C4.13374 3.89634 4.185 3.77261 4.185 3.64358V2.83277H7.10392V3.64358C7.10392 3.77261 7.15517 3.89634 7.24641 3.98758C7.33764 4.07881 7.46138 4.13007 7.59041 4.13007C7.71943 4.13007 7.84317 4.07881 7.9344 3.98758C8.02564 3.89634 8.07689 3.77261 8.07689 3.64358V2.83277H8.8877C9.10274 2.83277 9.30898 2.91819 9.46103 3.07025C9.61309 3.22231 9.69851 3.42854 9.69851 3.64358V5.42736H1.5904V3.64358C1.5904 3.42854 1.67583 3.22231 1.82789 3.07025C1.97994 2.91819 2.18618 2.83277 2.40122 2.83277ZM8.8877 11.5895H2.40122C2.18618 11.5895 1.97994 11.5041 1.82789 11.352C1.67583 11.2 1.5904 10.9938 1.5904 10.7787V6.40034H9.69851V10.7787C9.69851 10.9938 9.61309 11.2 9.46103 11.352C9.30898 11.5041 9.10274 11.5895 8.8877 11.5895Z"
      fill="#263154"
    />
  </svg>
);
